if (!customElements.get('wls-s-accordion')) {
  class WLS_S_Accordion extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        accordionItem: 'wls-s-accordion-item',
        accordionTrigger: 'wls-s-accordion-trigger',
        accordionContent: 'wls-s-accordion-content',
      };

      this.settings = {
        triggerMob: this.hasAttribute('data-trigger-mob'),
        triggerTab: this.hasAttribute('data-trigger-tab'),
        triggerDesk: this.hasAttribute('data-trigger-desk'),
        closeOthers: this.hasAttribute('data-close-others'),
      };

      this.boundToggleAccordion = this.toggleAccordion.bind(this);
      this.boundResizeHandler = debounce(this.handleResize.bind(this), 200);
    }

    connectedCallback() {
      this.init();
      window.addEventListener('resize', this.boundResizeHandler);
      this.boundCloseAllHandler = this.closeAllAccordions.bind(this);
      this.addEventListener('wls-s:accordion:close-all', this.boundCloseAllHandler);
    }

    disconnectedCallback() {
      this.teardown();
      window.removeEventListener('resize', this.boundResizeHandler);
      this.removeEventListener('wls-s:accordion:close-all', this.boundCloseAllHandler);
    }

    init() {
      this.selectors = {
        accordionItems: this.querySelectorAll(this.classes.accordionItem),
      };

      if (!this.shouldEnableAccordion()) return;

      this.selectors.accordionItems.forEach((item, index) => {
        const itemTrigger = item.querySelector(this.classes.accordionTrigger);
        if (itemTrigger) {
          itemTrigger.addEventListener('click', this.boundToggleAccordion);
        }
        const dataIndex = parseInt(item.getAttribute('data-index'), 10);
        const defaultIndex = parseInt(item.getAttribute('data-default-open-index'), 10);
        
        if (!isNaN(defaultIndex) && (defaultIndex === index || defaultIndex === dataIndex)) {
          this.openAccordion(item);
        }
      });
    }

    teardown() {
      if (!this.selectors || !this.selectors.accordionItems) return;
      this.selectors.accordionItems.forEach((item) => {
        const itemTrigger = item.querySelector(this.classes.accordionTrigger);
        if (itemTrigger) {
          itemTrigger.removeEventListener('click', this.boundToggleAccordion);
        }
      });
    }

    handleResize() {
      this.teardown();
      this.init();
    }

    shouldEnableAccordion() {
      const width = window.innerWidth;
      const { triggerMob, triggerTab, triggerDesk } = this.settings;
      if (!triggerMob && !triggerTab && !triggerDesk) return true;
      if (triggerMob && width <= 767) return true;
      if (triggerTab && width > 767 && width <= 1023) return true;
      if (triggerDesk && width > 1023) return true;
      return false;
    }

    toggleAccordion(e) {
      const item = e.currentTarget.closest(this.classes.accordionItem);
      const isOpen = item.hasAttribute('data-expanded');
      const itemContent = item.querySelector(this.classes.accordionContent);
      const itemTrigger = item.querySelector(this.classes.accordionTrigger);

      if (!itemContent) return;

      if (isOpen) {
        itemContent.style.maxHeight = '0px';
        item.removeAttribute('data-expanded');
        if (itemTrigger) itemTrigger.setAttribute('aria-expanded', 'false');
      } else {
        if (this.settings.closeOthers) {
          this.closeAllAccordions();
        }
        this.openAccordion(item);
      }
    }

    openAccordion(item) {
      const itemContent = item.querySelector(this.classes.accordionContent);
      const itemTrigger = item.querySelector(this.classes.accordionTrigger);
      if (!itemContent) return;
      item.setAttribute('data-expanded', 'true');
      if (itemTrigger) itemTrigger.setAttribute('aria-expanded', 'true');
      itemContent.style.maxHeight = `${itemContent.scrollHeight}px`;
    }

    closeAllAccordions() {
      if (!this.selectors || !this.selectors.accordionItems) return;
      this.selectors.accordionItems.forEach((item) => {
        const itemContent = item.querySelector(this.classes.accordionContent);
        const itemTrigger = item.querySelector(this.classes.accordionTrigger);
        if (itemContent) itemContent.style.maxHeight = '0px';
        if (itemTrigger) itemTrigger.setAttribute('aria-expanded', 'false');
        item.removeAttribute('data-expanded');
      });
    }
  }

  window.customElements.define('wls-s-accordion', WLS_S_Accordion);
}
